import React, { useCallback, useContext, useEffect, useState } from 'react';
import '../../../libs/bulma.min.css';
import './formIpSetInterfaces.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function FormIPInterfaces(props) {
  const { iface, data, handleChangeValues } = props;
  const metrics = [ 1, 100, 200, 300 ];

  return (
    <div className="interface-form-card">
      <div className="interface-form-header">
        <svg className="interface-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
        </svg>
        <span className="interface-name">{ iface.includes('_') ? iface.split('_').join('.') : iface }</span>
      </div>
      <div className="interface-form-fields">
        <div className="interface-field">
          <label className="interface-label">IP</label>
          <input className="interface-input" name={`${iface}-ip`} type="text" placeholder="1.1.1.2" onBlur={(e) => handleChangeValues(e.target)} />
          <p name={`${iface}-ip-invalid-data`} className='interface-error is-hidden'>Caracteres inválidos!</p>
        </div>
        <div className="interface-field">
          <label className="interface-label">Máscara</label>
          <input className="interface-input" name={`${iface}-mask`} type="text" placeholder="255.255.255.0" onBlur={(e) => handleChangeValues(e.target)} />
          <p name={`${iface}-mask-invalid-data`} className='interface-error is-hidden'>Caracteres inválidos!</p>
        </div>
        <div className="interface-field">
          <label className="interface-label">Gateway</label>
          <input className="interface-input" name={`${iface}-gw`} type="text" placeholder="1.1.1.1" onBlur={(e) => handleChangeValues(e.target)} />
          <p name={`${iface}-gw-invalid-data`} className='interface-error is-hidden'>Caracteres inválidos!</p>
        </div>
        <div className="interface-field">
          <label className="interface-label">Métrica</label>
          <select className="interface-select" name={`${iface}-metric`} onChange={(e) => handleChangeValues(e.target)} >
            <option value="">Selecione</option>
            {metrics.map((metric) => <option key={metric} value={metric}>{ metric }</option>)}
          </select>
          <p name={`${iface}-metric-invalid-data`} className='interface-error is-hidden'>Caracteres inválidos!</p>
        </div>
      </div>
    </div>
  );
}

export default FormIPInterfaces;
